import * as Yup from "yup";
import axios from "axios";
import { isNonEmptyArray, isStringEqualCI } from "@/utils";

export class YupHelper {
  static testDuplicate = (
    value: string,
    context: Yup.TestContext<Yup.AnyObject>,
    url: string,
    idFieldName: string,
    valueFieldName: string
  ): Promise<boolean> =>
    new Promise((resolve) => {
      axios
        .get(`${url}${value}`)
        .then((response) => {
          if (
            isNonEmptyArray(response.data.data) &&
            response.data.data.filter(
              (item: any) =>
                item[idFieldName] != context.parent[idFieldName] &&
                isStringEqualCI(item[valueFieldName], value)
            ).length
          ) {
            resolve(false);
          }

          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
    });
}
